var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStateBoards({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 114,
    viewBox: "0 0 118 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.4512 44.56C71.0812 44.56 62.5612 44.22 54.5912 42C46.7712 39.83 39.5912 35.62 33.1912 30.75C29.0012 27.58 25.1912 25.06 19.7512 25.44C14.4282 25.7231 9.33746 27.711 5.23121 31.11C-1.68879 37.17 -0.648793 48.39 2.12121 56.26C6.28121 68.13 18.9412 76.39 29.7012 81.75C42.1312 87.96 55.7912 91.56 69.4812 93.64C81.4812 95.46 96.9012 96.79 107.301 88.95C116.851 81.75 119.471 65.31 117.131 54.21C116.564 50.9279 114.818 47.9658 112.221 45.88C105.511 40.98 95.5012 44.25 87.9612 44.42C85.1612 44.48 82.3112 44.54 79.4512 44.56Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9712 113.09C79.2456 113.09 95.6812 112.065 95.6812 110.8C95.6812 109.535 79.2456 108.51 58.9712 108.51C38.6969 108.51 22.2612 109.535 22.2612 110.8C22.2612 112.065 38.6969 113.09 58.9712 113.09Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.781 13.37C105.323 13.37 105.761 12.9312 105.761 12.39C105.761 11.8488 105.323 11.41 104.781 11.41C104.24 11.41 103.801 11.8488 103.801 12.39C103.801 12.9312 104.24 13.37 104.781 13.37Z",
    fill: "#CFCFCF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5913 5.16001C40.1326 5.16001 40.5713 4.72125 40.5713 4.18001C40.5713 3.63877 40.1326 3.20001 39.5913 3.20001C39.0501 3.20001 38.6113 3.63877 38.6113 4.18001C38.6113 4.72125 39.0501 5.16001 39.5913 5.16001Z",
    fill: "#CFCFCF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4412 98.47C51.9824 98.47 52.4212 98.0312 52.4212 97.49C52.4212 96.9488 51.9824 96.51 51.4412 96.51C50.8999 96.51 50.4612 96.9488 50.4612 97.49C50.4612 98.0312 50.8999 98.47 51.4412 98.47Z",
    fill: "#CFCFCF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6013 0.5V4.8",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4512 2.65002H79.7512",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54126 18.6V22.9",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.38135 20.75H9.69135",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7812 78.51V82.82",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62134 80.66H12.9313",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6313 34.42V38.72",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4812 36.57H101.781",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6606 9.33252L19.4676 15.9235C16.2144 16.3507 13.9235 19.3343 14.3506 22.5875L22.0011 80.849C22.4283 84.1023 25.4119 86.3932 28.6651 85.966L78.8581 79.375C82.1114 78.9478 84.4023 75.9643 83.9752 72.711L76.3246 14.4495C75.8975 11.1963 72.9139 8.90533 69.6606 9.33252Z",
    fill: "#D2D2D2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2813 17.88H33.5813C30.2953 17.88 27.6313 20.5439 27.6313 23.83V82.68C27.6313 85.9661 30.2953 88.63 33.5813 88.63H84.2813C87.5674 88.63 90.2313 85.9661 90.2313 82.68V23.83C90.2313 20.5439 87.5674 17.88 84.2813 17.88Z",
    fill: "white",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateBoards);
export default __webpack_public_path__ + "static/media/empty-state-boards.d9d4975194d0033186bbe62b328d00b4.svg";
export { ForwardRef as ReactComponent };